import React from 'react';
import { ShieldCheck, ArrowRight } from 'lucide-react';

const JoinCapsterButton = () => (
  <a href="https://wa.link/t3srkq">
    <button className="flex justify-center w-64 space-x-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white p-4 rounded-3xl hover:shadow-lg transform hover:scale-105 transition-all duration-300 hover:w-full hover:justify-evenly">
      <ShieldCheck className="w-6 h-6 animate-ping" />
      <span>Gabung Sekarang</span>
      <ArrowRight className="w-6 h-6" />
    </button>
  </a>
  
);

export default JoinCapsterButton;